export default "__VITE_ASSET__BHUHczTn__"